var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-end"},[_c('iframe',{staticStyle:{"width":"490px","height":"370px","padding-top":"4px"},attrs:{"src":"https://www.playtron.bet/betConsole/console/rocky/live.html","frameborder":"0"}})])
}]

export { render, staticRenderFns }